import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { useLocation } from 'react-router-dom';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { MetadataContent } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import _ from 'lodash';
import { Icon } from '@jutro/components';
import PropTypes from 'prop-types';
import { generateURL } from 'gw-portals-url-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './UserManager.metadata.json5';
import styles from './UserManager.module.scss';
//import cookie from 'js-cookie';

function UserManager() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const location = useLocation();
    const intl = useContext(IntlContext);
    const auth = useAuthentication();



    useEffect(() => {
            // disable re render
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
/*
Open Payroll Reports:
/auditpc/AuditController?l_usrid={userId}&access_type=t1&pn={policyNbr}

General Info Access:
/auditpc/AuditController?l_userId={userId}&access_type=t1&an={auditNbr}&sl={serviceLocNbr}&navto=GENERALINFO&ts={timestamp in form of HHmmss}

*/
    const generateUserManagerURL = () => {
        const getUrl = window.location;
        const baseUrl = `${getUrl.origin}/admin/mypolicy/#/usermanager`;
        //const baseUrl = `https://ladwpolgpe1.ri-net.com/auditpc/AuditController`;
        // const redirectRoute = _.get(appConfig, 'documentNotFoundRedirectUrl') || '';
        // const userId = (auth.user_name).replace("policyholder_portal_","");
        //cookie.set('token', authHeader.Authorization.replace("Bearer ", ""));
        let params = {};
        return generateURL(baseUrl, params);
    };    


    const getUserManagerHeader = () => {
        return (
            <>
                 <div className={styles.gwTypeWithLOB}>

                    <Icon icon="mi-verified_user" className={styles.syncIcon} />
        <h1 className={styles.gwPageTitle}>User Manager</h1>
                </div>
            </>
        );
    };

    const overrides = {
        iframeUserManager : {
            src : generateUserManagerURL()
        },
        tabPaymentTitle: {
            content: ""
        },           
     };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
        }
    };

    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default UserManager;